import React, {useState} from "react";
import {Box, Button, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ReactComponent as EditNoFillIcon} from "../../../../../../../assets/edit_no_fill_icon.svg";
import {ReactComponent as DeleteNoFillIcon} from "../../../../../../../assets/delete_no_fill_icon.svg";
import {FlyerClassDto} from "../../../../../../../dtos";
import {useDispatch} from "react-redux";
import {deleteFlyerClass} from "../../../../../../../store/actionCreators/flyerClassesActionCreators";

const useStyles = makeStyles(() => ({
    flyerClassWrap: {
        "&:hover": {
            backgroundColor: "#dddddd"
        }
    },
    flyerClassRow: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #E4E4E4",
        padding: "12px",
    }
}))

interface Props {
    flyerClassData: FlyerClassDto;
    editNewFlyerClass: (flyerClass: FlyerClassDto) => void;
}

export const FlyerClass: React.FC<Props> = ({
                                                flyerClassData,
                                                editNewFlyerClass
                                            }) => {
    const dispatch = useDispatch();
    const [showActions, setShowAction] = useState<boolean>(false);
    const classes = useStyles();

    const onEdit = () => {
        editNewFlyerClass(flyerClassData);
    }
    const onDelete = () => {
        dispatch(deleteFlyerClass([Number(flyerClassData.id)]));
    }

    return (
        <Box className={classes.flyerClassWrap}
             onMouseEnter={() => {
                 setShowAction(true);
             }}
             onMouseLeave={() => {
                 setShowAction(false);
             }}
        >
            <Box className={classes.flyerClassRow}>
                <Typography fontSize={"14px"} lineHeight={"24px"}>
                    {flyerClassData.caption}
                </Typography>
                {showActions &&
                    <Box
                        sx={{
                            display: "flex",
                            flexFlow: "row",
                            columnGap: "8px"
                        }}
                    >
                        <Button
                            onClick={onEdit}
                            sx={{
                                width: "24px",
                                height: "24px",
                                padding: "2px"
                            }}
                        >
                            <EditNoFillIcon style={{
                                width: "100%",
                                height: "100%"
                            }}/>
                        </Button>
                        <Button
                            onClick={onDelete}
                            sx={{
                                width: "24px",
                                height: "24px",
                                padding: "2px"
                            }}
                        >
                            <DeleteNoFillIcon style={{
                                width: "100%",
                                height: "100%"
                            }}/>
                        </Button>
                    </Box>
                }
            </Box>
        </Box>
    )
}